module.exports = __webpack_public_path__ + "img/top.b280e7f8.png";